export const en = {
    placeholder: 'example@company-name.ru',
    continue: 'Continue',
    domain_support: "Domain {domain} is not supported at the moment\nSpecify the email that is linked to your company's domain",
    email_required: 'Email is required',
    email_invalid: 'Invalid email format',
    error_title: 'An error occurred',
    error_message: 'Please try again later',
};
